/**
 * The journey every user has, under a document id nobody else can take.
 *
 * Reserved rather than generated, so the plan's own journey is the same one on
 * every device and after every reinstall — and so anything that later belongs
 * to a journey can name this one without having to look it up.
 */
export const BASE_JOURNEY_ID = 'base'

/** What it is called until the user calls it something else. */
export const DEFAULT_BASE_JOURNEY_NAME = 'Financial security'

export const isBaseJourney = (id: string): boolean => id === BASE_JOURNEY_ID
